<template>
    <div class="page">
        <div class="page-header hidden-sm-and-down">
            <div style="float:right">
                <slot name="buttons"></slot>
            </div>
            <el-page-header @back="$router.go(-1)" :content="title"/>
        </div>
        <slot name="jibenxinxi"></slot>
        <div class="page-search">
            <slot name="search"></slot>
        </div>
        <slot name="tabs"></slot>
        <div class="page-main">
            <el-table :data="table.data" style="width: 100%;cursor: pointer" height="100%" v-loading="loading" size="mini" border @selection-change="handleSelectionChange" @row-click="handleRowChange" :span-method="objectSpanMethod">
                <slot></slot>
            </el-table>
        </div>
        <div class="page-footer">
            <el-pagination layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
                           :current-page="table.page" :total="table.total" :page-size="table.pageSize"
                           @current-change="handleCurrentChange"
                           @size-change="handleSizeChange"/>
        </div>
        <slot name="dialog"></slot>
    </div>
</template>


<script>
    export default {
        name: 'zk-admin-table',
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: '页面标题'
            },
            rowSpanArr:{
                type: Array,
                default: () => []
            },
            table: {
                default: {
                    search: [],
                    columns: [],
                    data: [],
                    total: 0,
                },
            },
        },
        methods: {
            handleCurrentChange(e) {
                this.table.page = e
                this.$emit('change', this.table)
            },
            handleSizeChange(e) {
                this.table.pageSize = e
                this.table.page = 1
                this.$emit('change', this.table)
            },
            handleSelectionChange(val) {
                this.$emit('select', val)
            },
            handleRowChange(row, column){
                this.$emit('row-click', row,column)
            },
            // eslint-disable-next-line no-unused-vars
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if(this.rowSpanArr.length) {
                    if (columnIndex === 0) {
                        const _row = this.rowSpanArr[rowIndex];
                        return {
                            rowspan: _row, //行
                            colspan: 1 //列
                        };
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .page {
        display: flex;
        flex-direction: column;
        /*justify-content: flex-start;*/
        /*align-items: flex-start;*/
        height: 100%;

        .page-header {
            padding-bottom: 10px;
        }

        .page-search {
            background-color: #f7f7f8;
            border: 1px solid #EBEEF5;
            border-bottom: 0px;
            text-align: center;

            .el-form-item {
                margin: 0 5px;
            }

        }

        .page-main {
            flex: 1;
            min-height: 100px;
        }

        .page-footer {
            text-align: center;
            padding-top: 20px;
        }
    }
</style>
